import { EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-waterfall-selection',
  templateUrl: './waterfall-selection.component.html',
  styleUrls: ['./waterfall-selection.component.less']
})
export class WaterfallSelectionComponent {
  @Input() assets;
  @Input() title;
  @Output() onDelete = new EventEmitter();
  isEdit = false;
  posterType = environment.features.posterType;
  constructor(private dialogService: DialogService) { }

  /** Change the selection value into an item */
  select(asset) {
    asset.isSelected = !asset.isSelected;
  }

  /** Sent delete output message */
  delete() {
    const selectedItems = this.assets.filter(obj => obj.isSelected == true);
    if (selectedItems.length) {
      this.dialogService.openConfirmDialog({
        title: "info_delete_title",
        message: "info_delete_msg",
        confirm: "gen_ok",
        cancel: "gen_cancel"
      }).subscribe(result => {
        if (result) {
          this.onDelete.emit(selectedItems);
        }
        this.isEdit = false;
      });
    } else {
      this.dialogService.openConfirmDialog({
        title: "info_delete_title",
        message: "info_delete_no_selected_msg",
        confirm: "gen_ok"
      }).subscribe(result => { });
    }
  }
}